import { isInShadow } from "@/utils/isInShadow";

const clickOutside = (
    node: HTMLElement,
    _options = {}
): {
    destroy: () => void;
} => {
    const options = { include: [], ..._options };

    function detect(event: MouseEvent | TouchEvent) {
        const target = isInShadow(node)
            ? event.composedPath()[0]
            : event.target;

        if (
            !node.contains(target as HTMLElement) ||
            options.include.some((i) => (target as HTMLElement).isSameNode(i))
        ) {
            node.dispatchEvent(new CustomEvent("clickOutside"));
        }
    }
    document.addEventListener("click", detect, {
        passive: true,
        capture: true,
    });
    document.addEventListener("touchstart", detect, {
        passive: true,
        capture: true,
    });

    return {
        destroy() {
            document.removeEventListener("click", detect);
            document.removeEventListener("touchstart", detect);
        },
    };
};

export default clickOutside;
